import React, { useState, useEffect } from 'react';

import { BoxArea, Subtract, Value, Add } from './style';
const NumericBox = ({ ...props }) => {

    const [value, setValue] = useState(parseInt(props.initialValue));

    const sub = () => {

        const v = value-1;
        const min = Number.isFinite(props.min) ? props.min : 0;

        if (v < min) {
            return;
        }

        if (v < 0) {
            if (props.allowNegative === true) {
                setValue(v);
                props.onChange(v);
            }
        } else {
            if (v === 0) {
                if (props.allowEmpty === true) {
                    setValue(v);
                    props.onChange(v);
                }

            } else {
                setValue(v);
                props.onChange(v);
            }
        }
    }
    
    const add = () => {
        const v = value+1;
        setValue(v);
        props.onChange(v);
    }

    useEffect(() => {
        props.onChange(props.initialValue);
    }, [props.initialValue])

    return (
        <BoxArea>
            <Subtract onClick={() => sub()}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                </svg>
            </Subtract>
            <Value>
                <label>{value}</label>
            </Value>
            <Add onClick={() => add()}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                </svg>
            </Add>
        </BoxArea>
    )
}

export default NumericBox;
